"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconAccessorialsList = function SvgIconAccessorialsList(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    fill: "currentColor",
    fillRule: "evenodd",
    viewBox: "0 0 48 48",
    "aria-label": "accessorials list icon"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Accessorials List Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.5 11.574c0 2.059-1.679 3.728-3.75 3.728-2.071 0-3.75-1.67-3.75-3.728 0-2.06 1.679-3.728 3.75-3.728 2.071 0 3.75 1.669 3.75 3.728zm-3.75 8.698C5.679 20.272 4 21.942 4 24c0 2.059 1.679 3.728 3.75 3.728 2.071 0 3.75-1.67 3.75-3.728 0-2.059-1.679-3.728-3.75-3.728zm0 12.426c-2.071 0-3.75 1.67-3.75 3.728 0 2.06 1.679 3.728 3.75 3.728 2.071 0 3.75-1.669 3.75-3.728s-1.679-3.728-3.75-3.728zm7.5-18.328h27.5c.69 0 1.25-.557 1.25-1.243V10.02c0-.686-.56-1.242-1.25-1.242h-27.5c-.69 0-1.25.556-1.25 1.242v3.107c0 .686.56 1.243 1.25 1.243zm0 12.426h27.5c.69 0 1.25-.556 1.25-1.243v-3.106c0-.687-.56-1.243-1.25-1.243h-27.5c-.69 0-1.25.556-1.25 1.243v3.106c0 .687.56 1.243 1.25 1.243zm0 12.426h27.5c.69 0 1.25-.556 1.25-1.242v-3.107c0-.686-.56-1.243-1.25-1.243h-27.5c-.69 0-1.25.557-1.25 1.243v3.107c0 .686.56 1.242 1.25 1.242z"
  }));
};

var _default = SvgIconAccessorialsList;
exports.default = _default;